// extracted by mini-css-extract-plugin
export var bottomRightDock = "_40-0";